module.exports = __webpack_public_path__ + "static/media/info.d33cde8a.svg";